import { Component } from '@angular/core';
import { soundpostReconFlowSnapshotEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Recon Flow Snapshots') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreconflowsnapshot-form',
    templateUrl: './soundpostreconflowsnapshot.form.component.html'
})
export class soundpostReconFlowSnapshotFormComponent extends BaseFormComponent {
    public record!: soundpostReconFlowSnapshotEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

